<template>
    <div>
        <div class="layui-tab layui-tab-brief x-py32" lay-filter="tabs" v-if="oCourses.length > 0">
            <ul class="layui-tab-title">
                <li :class="index == 0 ? 'layui-this' : ''" v-for="(item, index) in items" :key="index"
                    :layui-id="item.type">{{ item.name }}</li>
            </ul>
            <div class="layui-tab-content x-round  x-mt24">
                <div class="layui-tab-item" :class="index == 0 ? 'layui-show' : ''" v-for="(item, index) in items"
                    :key="index">
                    <div v-for="(oDetail, m) in item.details" :key="m">
                        <ul class="layui-menu" v-if="item.type == 'hotel'">
                            <li class="layui-menu-item-group"
                                :class="m == 0 ? 'layui-menu-item-down' : ' layui-menu-item-up'">
                                <div class="layui-menu-body-title type">
                                    {{ m + 1 }}. {{ oDetail.type }}<i class="layui-icon layui-icon-up"></i>
                                </div>
                                <ul class="x-bg-grey x-round x-relative">
                                    <li class="" v-for="hourse in oDetail.details">
                                        <div class="x-float-right"><span class="price">{{ myUtils.getCurrentCurrency() }}{{
                                            myUtils.fixPrice(hourse.price) }}/周</span></div>
                                        <div class="detail">
                                            {{ hourse.detail }}
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="x-round x-relative" v-if="item.type == 'airport'">
                            <li>
                                <div class="x-float-right"><span class="price">{{ myUtils.getCurrentCurrency() }}{{
                                    myUtils.fixPrice(oDetail.price) }}/次</span></div>
                                {{ oDetail.airport }}
                            </li>
                        </ul>
                        <ul class="layui-menu" v-if="item.type == 'hotel-photos'">
                            <li class="layui-menu-item-group"
                                :class="m == 0 ? 'layui-menu-item-down' : ' layui-menu-item-up'">
                                <div class="layui-menu-body-title type">
                                    {{ m + 1 }}. {{ oDetail.type }}<i class="layui-icon layui-icon-up"></i>
                                </div>
                                <ul class="x-bg-grey x-round x-relative">
                                    <li class="carousel-box">
                                        <div class="layui-carousel" :id="`ID-carousel-${m}`">
                                            <div carousel-item>
                                                <div class="hotel-img" v-for="pic in oDetail.photos.data" :src="myUtils.getUrlPic(pic,'large')">
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>


<style scoped>
.price {
    color: var(--functional-red-3, #EF454A);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.layui-tab-content {
    border: 1px solid #F4F5F6;
}

.layui-tab-title li {
    font-size: 24px
}

.layui-tab-item {
    /* margin-top: 30px; */
}

.layui-menu .type {
    margin: 12px 0;
    color: var(--text-text-primary, #2B2F33);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.layui-menu .x-round {
    padding: 16px 16px;
}

.detail-box {
    padding: 24px;
    margin: 16px 0;
}

.detail {
    color: var(--text-text-primary, #2B2F33);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 6px 0;
    white-space: normal;
}

.layui-menu {}

.layui-menu .layui-menu-item-checked:after {
    border-right: none;
}

.layui-tab-brief>.layui-tab-title .layui-this {
    color: #2B2F33;
}

.layui-tab-brief>.layui-tab-more li.layui-this:after,
.layui-tab-brief>.layui-tab-title .layui-this:after {
    border-bottom-color: #FFE117;
}

.hotel-img {
    width: 100%;
    height: 100%;
}
.carousel-box{
    height:200px;
}
@media screen and (min-width: 768px) {
    .carousel-box{
    height:360px;
}
}
</style>
<style>
.hotel-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.layui-carousel .layui-carousel-ind li{
    padding:0;
}
</style>


<script setup>


// const items = ref([
//     {
//         name: "住宿",
//         details : [
//             {
//                 type : '学生公寓',
//                 details : [
//                     {
//                         detail : "单人套房公寓(配置简易厨房/1区)",
//                         price : "597"
//                     }
//                 ]
//             }
//         ]
//     },
//     {
//         name : '接机',
//         details : [

//         ]
//     }
// ]);
const items = ref([]);
const props = defineProps({
    data: Object
})
const aItems = [];
const oCourses = [];
if (props.data.data.attributes.hotel && props.data.data.attributes.hotel.length > 0) {
    oCourses.push({
        name: "住宿",
        type: "hotel",
        details: props.data.data.attributes.hotel
    })
}
if (props.data.data.attributes.airport_transfer && props.data.data.attributes.airport_transfer.length > 0) {
    oCourses.push({
        name: '接机',
        type: "airport",
        details: props.data.data.attributes.airport_transfer
    })
}

let oHotelPics;
if (props.data.data.attributes.hotel_photos && props.data.data.attributes.hotel_photos.length > 0) {
    oHotelPics = {
        name: "住宿照片",
        type: "hotel-photos",
        details : props.data.data.attributes.hotel_photos
        // details: [
        //     {
        //         type: "公寓",
        //         pics: [
        //             "https://www.xiaoou.cc/uploads/medium_Map_e1509fb5ba.png",
        //             "https://www.xiaoou.cc/uploads/thumbnail_1_020826a5c8.jpg"
        //         ]
        //     },
        //     {
        //         type: "宿舍",
        //         pics: [
        //             "https://www.xiaoou.cc/uploads/33abd4d6_0d28_4605_82cc_c18e12c107cb_44ceb26b2f.png",
        //             "https://www.xiaoou.cc/uploads/small_microsoftteams_image_6_42baef60e4.png"
        //         ]
        //     }
        // ]
    }
    oCourses.push(oHotelPics);
}

items.value = oCourses;


function initPics(i) {
    layui.use(function () {
        var carousel = layui.carousel;
        // 渲染 - 图片轮播
        carousel.render({
            elem: '#ID-carousel-' + i,
            width: '100%',
            height: '100%',
            interval: 3000,
            autoplay : false
        });
    });
    var aDiv = document.getElementById('ID-carousel-' + i).querySelectorAll('.hotel-img');
    aDiv.forEach((div) => {
        var img = document.createElement('img');
        img.src = div.getAttribute('src');
        div.appendChild(img);
    })

}

onMounted(() => {
    if (!oHotelPics) {
        return;
    }
    layui.element.on('tab(tabs)', function (data) {
        for (var i = 0; i < oHotelPics.details.length; i++) {
            initPics(i);
        }
    });
});
</script>